import { UserMenuSchemaEntry } from '@bucketplace/design-system';

import { EventUserProfileType } from 'types';
import { OHS_HOST, PARTNERS_HOST, PRO_HOST } from 'common';

const getLoginPath = (path: string, user?: EventUserProfileType | null)
: string => {
  if (user != null) {
    return path;
  }
  return `${OHS_HOST}/users/sign_in?redirect_to=${encodeURIComponent(path)}`;
};

export const getUserMenu = (
  signOut: () => void,
  user?: EventUserProfileType | null
): UserMenuSchemaEntry[] => {
  return [
    {
      title: '마이페이지',
      href: user != null
        ? `${OHS_HOST}/users/${user.userId}`
        : `${OHS_HOST}/users/sign_in`,
      showOn: ['drawer', 'bar'],
    },
    {
      title: '나의 쇼핑',
      href: getLoginPath(`${OHS_HOST}/user_shopping_pages/order_list`, user),
      showOn: ['drawer', 'bar'],
    },
    {
      title: '스크랩북',
      href: user != null
        ? `${OHS_HOST}/users/${user.userId}/collections`
        : `${OHS_HOST}/users/sign_in`,
      showOn: ['drawer'],
    },
    {
      title: '알림',
      href: getLoginPath(`${OHS_HOST}/notifications/feed`, user),
      showOn: ['drawer'],
    },
    {
      title: '이벤트',
      href: `${OHS_HOST}/competitions/feed`,
      showOn: ['drawer', 'bar'],
    },
    {
      title: '사진 올리기',
      href: getLoginPath(`${OHS_HOST}/contents/card_collections/new`, user),
      showOn: ['drawer'],
    },
    {
      title: '집들이 글쓰기',
      href: getLoginPath(`${OHS_HOST}/projects/write`, user),
      showOn: ['drawer'],
    },
    {
      title: '노하우 글쓰기',
      href: getLoginPath(`${OHS_HOST}/advices/write`, user),
      showOn: ['drawer'],
    },
    {
      title: '상품 리뷰 쓰기',
      href: getLoginPath(`${OHS_HOST}/production_reviews/write`, user),
      showOn: ['drawer'],
    },
    {
      title: '시공 전문가 리뷰 쓰기',
      href: getLoginPath(`${OHS_HOST}/expert_reviews/new?source=6`, user),
      showOn: ['drawer'],
    },
    user == null || user.userableType !== 'ExpertUser'
      ? {
        title: '전문가 신청',
        href: `${PRO_HOST}/?utm_source=ohouse&utm_medium=web&utm_campaign=prosignup&utm_content=myhome`,
        showOn: ['bar'],
        type: 'bottom',
      }
      : null,
    user == null || user.userableType !== 'SalesUser'
      ? {
        title: '판매자 신청',
        href: `${PARTNERS_HOST}/partner/applications/new`,
        showOn: ['bar'],
        type: 'bottom',
      }
      : null,
    {
      title: '고객센터',
      href: `${OHS_HOST}/customer_center`,
      showOn: ['drawer', 'bar'],
    },
    user != null
      ? {
        title: '로그아웃',
        showOn: ['bar'],
        type: 'bottom',
        onClick: signOut,
      }
      : null,
  ].filter((menu) => menu != null) as UserMenuSchemaEntry[];
};
